const t={exact:1,fraction:.5};export{t as PrecisionMap};
